import React, {useEffect, useState} from "react";

import AddIcon from "@mui/icons-material/Add";
import {Button, Grid2} from "@mui/material";
import Paper from "@mui/material/Paper/Paper";
import {EnhancedTableToolbar} from "components/advertising/commonComponents";
import {cloneDeep} from "lodash";
import log from "loglevel";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";
import FilmCardView from "../FilmCardView";
import {FilmList} from "../container";
import "./styles.scss";
import { currentUserSelector } from "../../login/logic/actions";
import { isReadOnlyRole } from "../../login/logic/sagas";
import Pagination from "components/common/Pagination";

const orderFieldsEnabled = [
    { id: "ENTERED_DATE", label: "Entered" },
    { id: "TITLE", label: "Title" },
];

function FilmListView(props) {
    const {
        selectedFilmRelease,
        onChangePage,
        onChangeMaxResults,
        isListView,
        toggleFilmReleaseForm,
        order,
        orderBy,
        onRefresh,
        changeOrder,
        filmReleaseFormOpen,
        filmReleaseHistory,
        onSelectFilmReleaseHistory,
        filmReleaseHistoryList,
    } = props;

    const [formIsOpen, setFormIsOpen] = useState(false);
    const user = useSelector(currentUserSelector);
    useEffect(() => {
        const wasOpen = cloneDeep(formIsOpen && !filmReleaseFormOpen);
        setFormIsOpen(filmReleaseFormOpen);
        if (wasOpen && isListView) {
            onRefresh();
        }
    }, [filmReleaseFormOpen, formIsOpen, isListView, onRefresh]);

    const handleRequestSort = (event, property) => {
        const isDesc = props.orderBy === property && props.order === "DESC";
        changeOrder({
            order: isDesc ? "ASC" : "DESC",
            orderBy: property,
        });
    };

    const loadFilmReleaseId = selectedFilmRelease && selectedFilmRelease.id ? selectedFilmRelease.id : null;
    return (
        (<Grid2 id="film-list-views" container direction={"column"} spacing={3}>
            {}
            <Grid2 className="film-card-view-wrapper"  size={12}>
                {!isListView && (
                    <React.Fragment>
                        {}
                        {!isReadOnlyRole(user) && <Button
                            size={"small"}
                            variant={"outlined"}
                            startIcon={<AddIcon />}
                            onClick={() => toggleFilmReleaseForm()}
                            style={{ marginBottom: 25, marginTop: 27 }}
                        >
                            Add Film Release
                        </Button>}
                        {}
                        <FilmCardView showHistory={true} filmReleaseHistoryList={filmReleaseHistoryList} loadFilmReleaseId={loadFilmReleaseId} filmReleaseHistory={filmReleaseHistory} onSelectFilmReleaseHistory={onSelectFilmReleaseHistory} defaultExpanded={true} />
                    </React.Fragment>
                )}
            </Grid2>
            {isListView && (
                <Paper style={{ width: "100%" }}>
                    <Grid2 size={12}>
                        <EnhancedTableToolbar
                            numSelected={0}
                            orderByFields={orderFieldsEnabled}
                            onSelectField={handleRequestSort}
                            onRefresh={onRefresh}
                            orderBy={orderBy}
                            order={order}
                            addText={"Add Film Release"}
                            onAdd={() => toggleFilmReleaseForm()}
                            noSelection
                        />
                        <FilmList />
                        <TableFooter onChangePage={onChangePage} onChangeMaxResults={onChangeMaxResults} />
                    </Grid2>
                </Paper>
            )}
        </Grid2>)
    );
}

FilmListView.propTypes = {
    selectedFilmRelease: PropTypes.object,
    onChangePage: PropTypes.func,
    onChangeMaxResults: PropTypes.func,
    isListView: PropTypes.bool,
    toggleFilmReleaseForm: PropTypes.func,
    order: PropTypes.string,
    orderBy: PropTypes.string,
    onRefresh: PropTypes.func,
    changeOrder: PropTypes.func,
    filmReleaseFormOpen: PropTypes.bool,
};



function TableFooter({ onChangePage, onChangeMaxResults }) {
    const totalCount = useSelector((state) => state.filmReleaseList.totalCount);
    const maxResults = useSelector((state) => state.filmReleaseList.maxResults);
    const page = useSelector((state) => state.filmReleaseList.page);
    log.debug("filmTable", {totalCount, maxResults, page});
    function handleChangePage( page) {
        onChangePage(page);
    }

    function handleChangeRowsPerPage(maxResults) {
        log.debug(maxResults);
        onChangeMaxResults(maxResults);
    }

    return (
        <div style={{ display: "flex", flex: 1, justifyContent: "flex-end" }}>
            <div style={{ display: "flex" }}>
                <Pagination
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    count={totalCount}
                    rowsPerPageOptions={[10, 25, 50, 75, 100]}
                    rowsPerPage={maxResults}
                    page={page}
                    onPageChange={handleChangePage} />
            </div>
        </div>
    );
}

export default FilmListView;
